var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.865,
    height: 34.482,
    viewBox: "0 0 31.865 34.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.65 1.101L1.556 8.866a.688.688 0 00-.356.6v15.548a.686.686 0 00.356.6l14.094 7.767a.688.688 0 00.663 0l14.094-7.765a.686.686 0 00.356-.6V9.465a.688.688 0 00-.356-.6L16.313 1.101a.688.688 0 00-.663 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.409 25.617a.326.326 0 000-.648l-14.1-7.765a.688.688 0 00-.663 0l-14.09 7.764a.326.326 0 000 .648",
    strokeDasharray: "2 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.505 8.962l-14.572 8.143L1.361 8.962m29.146 0l-14.572 8.143v16.362"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "2 3",
    d: "M15.996 17.482V1.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.3b5aab1900346827e3e77b809bf5e0a4.svg";
export { ForwardRef as ReactComponent };